/* Copyright (c) 2020-present CloudIO Inc */

import { Platform } from '../../platform/Platform';
import { ComponentManagerFn } from '../../registry/Component.type';
import { baseComponentManager } from '../../registry/Components';
import { defaultValue } from './ToolbarSpacer';

const ToolbarSpacerManager: ComponentManagerFn<'ToolbarSpacer'> = (
  platform: Platform,
) => {
  return {
    ...baseComponentManager<'ToolbarSpacer'>(platform, 'ToolbarSpacer'),
    type: 'ToolbarSpacer',
    name: 'Toolbar Filler',
    defaultValue,
    props: {},
    category: 'Toolbar',
    icon: { iconName: 'rectangle-wide' },
    description: `**Overview**<br/>
The Toolbar Filler (technically ToolbarSpacer) is a layout utility component designed to manage the distribution of empty space within a Toolbar. It acts as a flexible spring that expands to occupy all available remaining space in the container.
Use this component to control the alignment of toolbar items, such as pushing a group of buttons to the far right while keeping a title on the left.

**1. Functionality**<br/>
* **Space Management:** When placed between two items, the Filler expands to push them as far apart as possible.
* **Alignment Control:** It is the primary mechanism for creating "Left-Right" or "Center" layouts in a flexbox-style toolbar system without writing custom CSS.

**2. Configuration**<br/>
* **Zero Configuration:** Like the Divider, this component has no properties (props: {}). Its behavior is automatic based on the size of the toolbar and the other items present.

**3. Best Use Cases**<br/>
* **Right Alignment:** Place a Filler immediately after the left-aligned items (like a Logo or Title) to push all subsequent items (like "Login" or "Search") to the far right edge.
* **Centering:** Place a Filler on both sides of an item to center it within the bar.`,
  };
};

export default ToolbarSpacerManager;
